var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "language-proficiency" },
    [
      _c(
        "form",
        {
          ref: "form",
          attrs: { method: "post", enctype: "multipart/form-data" }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "_csrfToken" },
            domProps: { value: _vm.csrfToken }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "fail_reason" },
            domProps: { value: _vm.fail_reason }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "skill_assessment_status" },
            domProps: { value: _vm.skill_assessment_status }
          }),
          _vm._v(" "),
          _vm._l(_vm.jobApplication.skill_assessment_results, function(
            skillAssessment,
            i
          ) {
            return _c(
              "div",
              {
                key: skillAssessment.id,
                staticClass: "bg-white rounded p-4 pb-0 pt-2"
              },
              [
                _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
                  _c("div", { staticClass: "cell small-7" }, [
                    _c("div", { staticStyle: { width: "90%" } }, [
                      _c("input", {
                        attrs: {
                          type: "hidden",
                          name:
                            "skill_assessment_results[" +
                            skillAssessment.skill_assessment_spec.id +
                            "][id]"
                        },
                        domProps: { value: skillAssessment.id }
                      }),
                      _vm._v(" "),
                      _c("b", [_vm._v("Assessment " + _vm._s(i + 1) + ": ")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(skillAssessment.skill_assessment_spec.title)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-control skill-assessment-item" },
                        [
                          skillAssessment.file_path
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "bg-white p-3 mb-2 d-flex justify-content-between"
                                },
                                [
                                  _c("label", { staticClass: "fw-bold" }, [
                                    _vm._v("Files Uploaded")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "text-decoration": "none",
                                        color: "#6ABC45"
                                      },
                                      attrs: {
                                        target: "_blank",
                                        href: "" + skillAssessment.file_path_cdn
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.sliceString(
                                            skillAssessment.file_path_cdn
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.skill_assessment_status ||
                          _vm.skill_assessment_status.length === 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "bg-white p-3 mb-2 grid-x justify-content-between"
                                },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "fw-bold cell small-4" },
                                    [
                                      skillAssessment.file_path_cdn
                                        ? _c("span", [
                                            _vm._v("Update uploaded File")
                                          ])
                                        : _c("span", [_vm._v("Upload file")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "cell small-8",
                                    attrs: {
                                      type: "file",
                                      name:
                                        "skill_assessment_results[" +
                                        skillAssessment.skill_assessment_spec
                                          .id +
                                        "][file_path]"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    attrs: {
                                      type: "hidden",
                                      name:
                                        "skill_assessment_results[" +
                                        skillAssessment.skill_assessment_spec
                                          .id +
                                        "][skills_assessment_specs_id]"
                                    },
                                    domProps: {
                                      value:
                                        "" +
                                        skillAssessment.skill_assessment_spec.id
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [_vm._v("Recruiter Score:")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center gap-2" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: skillAssessment.score,
                                    expression: "skillAssessment.score"
                                  }
                                ],
                                staticClass: "bg-white",
                                staticStyle: { width: "unset" },
                                attrs: {
                                  type: "number",
                                  step: "1",
                                  min: "0",
                                  max: "100",
                                  required: "",
                                  name:
                                    "skill_assessment_results[" +
                                    skillAssessment.skill_assessment_spec.id +
                                    "][score]"
                                },
                                domProps: { value: skillAssessment.score },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      skillAssessment,
                                      "score",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("%")])
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell small-5" }, [
                    _vm._m(0, true),
                    _vm._v(" "),
                    _c("span", {
                      staticStyle: {
                        "white-space": "pre-line",
                        "font-size": ".9rem"
                      },
                      domProps: {
                        innerHTML: _vm._s(
                          skillAssessment.skill_assessment_spec.instructions
                        )
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                i < _vm.jobApplication.skill_assessment_results.length - 1
                  ? _c("hr")
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm.jobApplication.skill_assessment_results.length === 0
            ? _c(
                "div",
                [
                  _c("p", { staticClass: "mb-6" }, [
                    _vm._v("Candidate has not uploaded any audio clips")
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.jobApplication.job.requisition.person_specification
                      .skill_assessment_specs,
                    function(skillAssessmentSpec, i) {
                      return _c(
                        "div",
                        {
                          key: "skillAssesement" + skillAssessmentSpec.id,
                          staticClass: "grid-x bg-white padding-10"
                        },
                        [
                          _c("div", { staticClass: "cell small-6" }, [
                            _c("strong", [
                              _vm._v("Assessment " + _vm._s(i + 1) + ":")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "grid-x grid-padding-x" },
                              [
                                _c("div", { staticClass: "cell small-6" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(skillAssessmentSpec.title) +
                                      "\n                        "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "cell small-6" }, [
                                  _c("input", {
                                    attrs: {
                                      type: "file",
                                      name:
                                        "skill_assessment_results[" +
                                        skillAssessmentSpec.id +
                                        "][file_path]"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    attrs: {
                                      type: "hidden",
                                      name:
                                        "skill_assessment_results[" +
                                        skillAssessmentSpec.id +
                                        "][skills_assessment_specs_id]"
                                    },
                                    domProps: {
                                      value: "" + skillAssessmentSpec.id
                                    }
                                  })
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cell small-5 ml-30" }, [
                            _c("strong", [_vm._v("Instructions:")]),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "mt-10",
                              domProps: {
                                innerHTML: _vm._s(
                                  skillAssessmentSpec.instructions
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          i <
                          _vm.jobApplication.job.requisition
                            .person_specification.skill_assessment_specs
                            .length -
                            1
                            ? _c("hr")
                            : _vm._e()
                        ]
                      )
                    }
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.jobApplication.skill_assessment_results.length > 0 &&
          (_vm.skill_assessment_status &&
            _vm.skill_assessment_status.length > 0)
            ? _c(
                "div",
                { staticClass: "px-4" },
                [
                  _c("hr", { staticStyle: { "max-width": "unset" } }),
                  _vm._v(" "),
                  _vm.jobApplication.skill_assessment_status != null
                    ? [
                        _c("strong", [_vm._v("Final Status: ")]),
                        _vm._v(" "),
                        _c("span", {}, [
                          _vm._v(
                            _vm._s(_vm.jobApplication.skill_assessment_status)
                          )
                        ]),
                        _vm._v(" "),
                        _vm.logs !== null && _vm.logs !== ""
                          ? _c("span", [
                              _vm._v(
                                "\n                     (Updated By " +
                                  _vm._s(_vm.logs.user.first_name) +
                                  " " +
                                  _vm._s(_vm.logs.user.last_name) +
                                  " - " +
                                  _vm._s(_vm.convertDate(_vm.logs.created)) +
                                  ")\n                "
                              )
                            ])
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "grid-x grid-padding-x px-4" }, [
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button px-5",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.saveProgress()
                    }
                  }
                },
                [_vm._v("Save Progress")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button px-5",
                  attrs: {
                    type: "button",
                    disabled: _vm.passBtnDisabled || _vm.disabled
                  },
                  on: {
                    click: function($event) {
                      return _vm.disablePassBtn()
                    }
                  }
                },
                [_vm._v("Pass")]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c("button", {
                ref: "failedButton",
                staticClass: "d-none",
                attrs: { value: "failed", name: "skill_assessment_status" }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button alert px-5",
                  attrs: { disabled: _vm.disabled, type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.toggleModal("failModal")
                    }
                  }
                },
                [_vm._v("Fail")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button recycle px-5",
                  attrs: { disabled: _vm.disabled, type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.toggleModal("recycleModal")
                    }
                  }
                },
                [_vm._v("Recycle")]
              )
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("recycle-modal", {
        ref: "recycleModal",
        attrs: {
          "job-application": _vm.jobApplication,
          "csrf-token": _vm.csrfToken
        }
      }),
      _vm._v(" "),
      _c("fail-modal", {
        ref: "failModal",
        attrs: { "job-application": _vm.jobApplication },
        on: { submit: _vm.fail }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fw-bold" }, [
      _c("small", [_vm._v("Instructions:")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3a926f4", { render: render, staticRenderFns: staticRenderFns })
  }
}